export default {
  workOrders: 'Work Orders',
  'workOrders.domain.number': 'Number',
  'workOrders.domain.company': 'Company',
  'workOrders.domain.customer': 'Customer',
  'workOrders.domain.vehicle': 'Vehicle',
  'workOrders.domain.vehicle.licensePlate': 'License Plate',
  'workOrders.domain.vehicle.fleet': 'Fleet',
  'workOrders.domain.vehicle.model': 'Model',
  'workOrders.domain.vehicle.brand': 'Brand',
  'workOrders.domain.vehicle.color': 'Color',
  'workOrders.domain.complements': 'Complements',
  'workOrders.domain.complements.number': 'Number',
  'workOrders.domain.complements.estimator': 'Estimator',
  'workOrders.domain.complements.customerType': 'Customer Type',
  'workOrders.domain.complements.type': 'Type',
  'workOrders.domain.complements.insurer': 'Insurer',
  'workOrders.domain.complements.status': 'Status',
  'workOrders.domain.complements.accidentNumber': 'Claim Number',
  'workOrders.domain.complements.insurerDeductibleAmount':
    'Insurer Deductible Amount',
  'workOrders.domain.complements.entryDate': 'Entry Date',
  'workOrders.domain.complements.estimatedLeaveDate': 'Estimated Leave Date',
  'workOrders.domain.complements.authorizationDate': 'Authorization Date',
  'workOrders.domain.complements.closingDate': 'Closing Date',
  'workOrders.domain.complements.estimatedLeaveDate': 'Estimated Leave Date',
  'workOrders.domain.complements.returnDate': 'Delivery Date',
  'workOrders.domain.complements.prisma': 'Prisma',
  'workOrders.domain.complements.currentKilometers': 'Entry Kilometers',
  'workOrders.domain.complements.exitKilometers': 'Exit Kilometers',
  'workOrders.domain.complements.tankLevel': 'Tank Level',
  'workOrders.domain.complements.lastOilChange': 'Last Oil Change',
  'workOrders.domain.complements.lastOilChangeKilometers':
    'Last Oil Change (KM)',
  'workOrders.domain.complements.cost': 'Cost',
  'workOrders.domain.complements.customerCreate': 'Quick customer registration',
  'workOrders.domain.complements.customerEdit': 'Customer quick edit',
  'workOrders.domain.complements.vehicleCreate': 'Quick vehicle registration',
  'workOrders.domain.complements.vehicleEdit': 'Vehicle quick edit',
  'workOrders.domain.observations.observation': 'Observation',
  'workOrders.domain.observations.visibility': 'Visibility',

  'workOrders.domain.items.itemName': 'Description',
  'workOrders.domain.items.type': 'Type',
  'workOrders.domain.items.manufacturerCode': 'Manufacturer Code',
  'workOrders.domain.items.manufacturingCode': 'Manufacturer Code',
  'workOrders.domain.items.description': 'Description',
  'workOrders.domain.items.quantity': 'Qtd.',
  'workOrders.domain.items.quantityTime': 'Qtd./Time',
  'workOrders.domain.items.unitPrice': 'Unit Price',
  'workOrders.domain.items.unitCost': 'Unit Cost',
  'workOrders.domain.items.totalValue': 'Total Value',
  'workOrders.domain.items.discount': 'Discount (%)',
  'workOrders.domain.items.discountValue': 'Discount ($)',
  'workOrders.domain.items.partProvided': 'Part Provided',
  'workOrders.domain.items.subArea': 'Sub Area',
  'workOrders.domain.items.manufacturer': 'Manufacture',
  'workOrders.domain.items.supplier': 'Supplier',
  'workOrders.domain.items.isPaintedPart': 'Is Painted Part',
  'workOrders.domain.items.tag': 'Tag',
  'workOrders.domain.items.status': 'Status',
  'workOrders.domain.items.paint': 'Paint',
  'workOrders.domain.items.timeToPaint': 'Time to Paint',
  'workOrders.domain.items.repair': 'Repair',
  'workOrders.domain.items.timeToRepair': 'Time to Repair',
  'workOrders.domain.items.change': 'Change',
  'workOrders.domain.items.timeToChange': 'Time to Change',

  'workOrders.domain.enums.work_order_item_status.red':
    'Item Awaiting Quotation',
  'workOrders.domain.enums.work_order_item_status.yellow': 'Quotation Item',
  'workOrders.domain.enums.work_order_item_status.orange':
    'Item Purchased (Awaiting delivery)',
  'workOrders.domain.enums.work_order_item_status.blue': 'Item in Stock',
  'workOrders.domain.enums.work_order_item_status.green':
    'Item in Productivity',
  'workOrders.domain.enums.work_order_item_status.black': 'Typed piece',

  'workOrders.domain.enums.work_order_customer_type.private': 'Private',
  'workOrders.domain.enums.work_order_customer_type.insurance': 'Insurance',
  'workOrders.domain.enums.work_order_type.courtesy': 'Courtesy',
  'workOrders.domain.enums.work_order_type.insideCourtesy': 'Inside (Courtesy)',
  'workOrders.domain.enums.work_order_type.warranty': 'Warranty',
  'workOrders.domain.enums.work_order_type.work_order': 'Budget',
  'workOrders.domain.enums.work_order_type.total_loss': 'Total Loss',
  'workOrders.domain.enums.work_order_type.return': 'Return',
  'workOrders.domain.enums.work_order_type.revision': 'Revision',
  'workOrders.domain.enums.work_order_type.porto_battery':
    'Porto Battery (7051)',
  'workOrders.domain.enums.work_order_status.open': 'Open',
  'workOrders.domain.enums.work_order_status.authorized': 'Authorized',
  'workOrders.domain.enums.work_order_status.closed': 'Closed',
  'workOrders.domain.enums.work_order_status.cancelled': 'Cancelled',
  'workOrders.domain.enums.tank_level.full': 'Full',
  'workOrders.domain.enums.tank_level.seven_eights': 'Seven Eights',
  'workOrders.domain.enums.tank_level.three_quarters': 'Three Quarters',
  'workOrders.domain.enums.tank_level.half': 'Half',
  'workOrders.domain.enums.tank_level.quarter': 'Quarter',
  'workOrders.domain.enums.tank_level.one_eight': 'One Eight',
  'workOrders.domain.enums.tank_level.reserve': 'Reserve',
  'workOrders.domain.enums.tank_level.empty': 'Empty',
  'workOrders.domain.enums.observation_visibility.customer': 'Customer',
  'workOrders.domain.enums.observation_visibility.company': 'Workshop',
  'workOrders.domain.enums.observation_visibility.all': 'All',

  'workOrders.domain.enums.work_order_item_type.part': 'Part',
  'workOrders.domain.enums.work_order_item_type.service': 'Service',
  'workOrders.domain.enums.work_order_item_status.pending': 'Pending',
  'workOrders.domain.enums.work_order_item_status.done': 'Done',
  'workOrders.domain.enums.work_order_item_status.partial': 'Partial',

  'workOrders.create': 'Create New Work Order',
  'workOrders.create.summary': 'Summary',
  'workOrders.create.summary.customerNotSelected':
    'No customer has been selected.',
  'workOrders.create.summary.vehicleNotSelected':
    'No vehicle has been selected.',
  'workOrders.create.notifications.success.title': 'Success',
  'workOrders.create.notifications.success.description': 'Work Order created.',

  'workOrders.details.update': 'Update Work Order',
  'workOrders.details.update.notifications.success.title': 'Success',
  'workOrders.details.update.notifications.success.description':
    'Work Order updated.',

  'workOrders.details.createComplement': 'Create Complement',

  'workOrders.details.workshopData': 'Workshop Data',
  'workOrders.details.clientsData': "Client's data",
  'workOrders.details.vehicleData': 'Vehicle Data',
  'workOrders.details.authorizedBudgetItems':
    'Open budget authorized item history',

  'workOrders.details.complement': 'Complement',
  'workOrders.details.complement.info': 'Complement Info',
  'workOrders.details.complement.dates': 'Dates',
  'workOrders.details.complement.modal.title': 'ATTENTION TO GDPR!',
  'workOrders.details.complement.modal.description':
    'This client has not yet positioned itself on the GDPR. Is the customer aware of and authorizing the use of their data by the workshop?',
  'workOrders.details.complement.modal.checkbox':
    'Do not show this alert again for this customer.',

  'workOrders.notification.lgpd.information':
    'The GDPR reminder and consent settings can be changed in the customers tab.',
  'workOrders.notification.lgpd.change.success.title':
    'GDPR term saved successfully!',
  'workOrders.notification.lgpd.change.success.description':
    'The term GDPR can be customized in company settings and printed.',

  'workOrders.details.observations': 'Observations',
  'workOrders.details.observations.empty':
    "This Work Order doesn't have observations",

  'workOrders.details.observations.create': 'Create Observation',
  'workOrders.details.observations.create.notifications.success.title':
    'Success',
  'workOrders.details.observations.create.notifications.success.description':
    'Work Order Observation created.',

  'workOrders.details.observations.update': 'Update Observation',
  'workOrders.details.observations.update.notifications.success.title':
    'Success',
  'workOrders.details.observations.update.notifications.success.description':
    'Work Order Observation updated.',

  'workOrders.details.observations.remove.confirm.title': 'Remove observation',
  'workOrders.details.observations.remove.confirm.content':
    'Do you really want to delete the selected observation?',
  'workOrders.details.observations.remove.success.message': 'Success',
  'workOrders.details.observations.remove.success.description':
    'Observation removed.',

  'workOrders.details.items': 'Parts and Tasks',
  'workOrders.details.items.totalDiscountPart': 'Total Parts Discount',
  'workOrders.details.items.totalDiscountPart.invalidValue':
    'Invalid discount.',
  'workOrders.details.items.totalDiscountService': 'Total Tasks Discount',
  'workOrders.details.items.totalDiscountService.invalidValue':
    'Invalid discount',
  'workOrders.details.items.partTotal': 'Part Total',
  'workOrders.details.items.serviceTotal': 'Service Total',
  'workOrders.details.items.total': 'Total',

  'workOrders.details.items.changeDiscount': 'Change Discount',
  'workOrders.details.items.changeDiscount.notifications.success.title':
    'Success',
  'workOrders.details.items.changeDiscount.notifications.success.description':
    'Items discount updated.',

  'workOrders.details.items.add': 'Add Item',

  'workOrders.details.items.add.select': 'Select',
  'workOrders.details.items.add.select.description':
    'Select the type of item to add.',

  'workOrders.details.items.add.search': 'Search',
  'workOrders.details.items.add.search.description':
    'Search for the items to be added.',

  'workOrders.details.items.add.createParts': 'Register parts',
  'workOrders.details.items.add.createParts.description':
    'Fraga parts registration',

  'workOrders.details.items.add.setupItems': 'Setup',
  'workOrders.details.items.add.setupItems.description':
    'Setup the quantity and item details.',
  'workOrders.details.items.add.setupItems.items': 'Item',

  'workOrders.blankWorkOrder': 'Blank Work Order',

  'workOrders.blankChecklist': 'Blank Checklist',

  'workOrders.importWorkOrder': 'Import Work Order',

  'workOrders.fieldRequiredByConfigCompany':
    'Field marked as required in company settings',

  'workOrders.public.workOrder.view': 'Work Order',
};
